export default __webpack_public_path__ + "static/media/21.06205bb2.png";